export default __webpack_public_path__ + "static/media/Img-highlight.69807521.png";